export class CustomParamsAlertModel {
  AlertTypeID: number;
  AlertID: number;
}
